import * as React from 'react'

import { imageUploader } from '@owl-nest/behaviours'
import * as plume from '@ulule/owl-kit-components/next'

export type ImageUploaderFieldProps = {
  className?: string
  error?: string
  translations: plume.ImageUploaderProps['translations']
  onChange: (file: File) => void
  onRemove: () => void
}

export function ImageUploaderField(props: ImageUploaderFieldProps): React.ReactElement<any> {
  const [preview, setPreview] = React.useState<string | undefined>()
  const { onChange, onDrop } = imageUploader.useImageUploader({
    handleChange: async (file, url) => {
      props.onChange(file)
      setPreview(await url)
    },
  })

  return (
    <plume.ImageUploader
      className={props.className}
      error={props.error}
      onChange={onChange}
      onDrop={onDrop}
      previewSrc={preview}
      onRemove={onRemove}
      translations={props.translations}
    />
  )

  function onRemove() {
    props.onRemove()
    setPreview(undefined)
  }
}
